import React, { FC } from 'react';
import UpDownArrows from './UpDownArrows';
import ColumnSelector from './ColumnSelector';
import { ShowIcons } from '../types';

type Props = {
  tableStatus: number;
  onSetStatusTable: (status: number) => void;
  setShowModalTable: (hide: boolean) => void;
  iconsConfig: ShowIcons;
};

const ButtonsContainer: FC<Props> = ({ tableStatus, setShowModalTable, onSetStatusTable, iconsConfig }) => {
  return (
    <>
      {iconsConfig.arrows && <UpDownArrows tableStatus={tableStatus} onSetStatusTable={onSetStatusTable} />}
      {iconsConfig.columnSelector && <ColumnSelector setShowModalTable={setShowModalTable} />}
    </>
  );
};

export default ButtonsContainer;
